/* eslint-disable */
import { languageTag } from "../../runtime.js"
import * as en from "../en/marketplace_payout_after_sale.js"
import * as nl from "../nl/marketplace_payout_after_sale.js"
import * as de from "../de/marketplace_payout_after_sale.js"


/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en" | "nl" | "de" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const marketplace_payout_after_sale = (params = {}, options = {}) => {
	return {
		de: de.marketplace_payout_after_sale,
		en: en.marketplace_payout_after_sale,
		nl: nl.marketplace_payout_after_sale
	}[options.languageTag ?? languageTag()]()
}

